// CategoriesSection.jsx
import React from "react";
import { Link } from "react-router-dom";

import { product_categories } from "./index";
import Hero from "./Hero";

const CategoriesSection = ({ isHome }) => {
  const products = [
    {
      id: 1,
      title: "Dehydrated Products",
      image: product_categories.category1,
      slug: "dehydrated-products",
    },
    {
      id: 2,
      title: "Turmeric\nProducts",
      image: product_categories.category2,
      slug: "turmeric-powder",
    },
    {
      id: 3,
      title: "Chilly\nPowder & Spices",
      image: product_categories.category3,
      slug: "chilly-powder",
    },
  ];

  return (
    <>
      {!isHome && <Hero />}
      <section className="relative w-full max-w-7xl mx-auto px-4 py-20 bg-white overflow-hidden">
        {/* Decorative images */}
        <img
          src={require("../assets/decorative1.png")}
          className="absolute top-0 left-0 w-60 md:w-56 pointer-events-none"
          alt="Decorative"
        />
        <img
          src={require("../assets/decorative1.png")}
          className="absolute top-0 right-0 w-28 md:w-36 pointer-events-none"
          alt="Decorative"
        />
        <img
          src={require("../assets/decorative2.png")}
          className="absolute bottom-0 left-0 w-28 md:w-36 pointer-events-none"
          alt="Decorative"
        />
        <img
          src={require("../assets/decorative2.png")}
          className="absolute bottom-0 right-0 w-28 md:w-36  pointer-events-none"
          alt="Decorative"
        />

        {/* Title */}



        {/* Product cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 justify-items-center">
          {products.map((product) => (
            <Link
              to={`/categories/${product.slug}`}
              key={product.id}
              className="w-full max-w-[280px]"
            >
              <div className="relative flex flex-col items-center">
                {/* Circle image */}
                <div className="w-40 h-40 rounded-full bg-[#f7ebd0] shadow-lg flex items-center justify-center mb-[-3rem] z-10 relative">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-24 h-24 object-contain mx-auto"
                  />
                </div>

                {/* Card */}
                <div className="w-full bg-[#dab98a] rounded-xl shadow-md pt-20 pb-6 px-6 text-center z-0 hover:bg-[#c9a878] transition-colors">
                  <h3 className="text-xl md:text-xl font-semibold text-black leading-snug">
                    {product.title}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
          {/* {products.map((product) => (
      <div key={product.id} className="relative w-full max-w-[280px] flex flex-col items-center">
        <div className="w-40 h-40 rounded-full bg-[#f7ebd0] shadow-lg flex items-center justify-center mb-[-3rem] z-10 relative">
          <img
            src={product.image}
            alt={product.title}
            className="w-24 h-24 object-contain"
          />
        </div>

        <div className="w-full bg-[#dab98a] rounded-xl shadow-md pt-20 pb-6 px-6 text-center z-0">
          <h3 className="text-xl md:text-xl font-semibold text-black leading-snug">
            {product.title}
          </h3>
        </div>
      </div>
    ))} */}
        </div>
      </section>
    </>
  );
};

// StaticFeaturesSection.jsx
const StaticFeaturesSection = () => {
  const features = [
    "Rich Flavor",
    "Long Shelf Life",
    "No peeling, chopping, or tears",
    "Healthy & Natural",
  ];

  return (
    <section className="py-12 px-4 md:px-8 bg-amber-50">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-amber-800 mb-8">
          Pure Onion Goodness - Flavor That Lasts!
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center justify-center space-x-2"
            >
              <div className="w-2 h-2 bg-amber-700 rounded-full"></div>
              <p className="text-lg md:text-xl text-gray-700">{feature}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { CategoriesSection, StaticFeaturesSection };
